import fetch from '@/plugins/fetch'
import http from '@/plugins/http'
import queryString from 'query-string'
import utils from '@/plugins/utils'
import Cookie from 'js-cookie'
import { CLUE_CATEGORY, CLUE_SOURE } from '@/config/YuesaoConfig'
import { getSelectedCity } from '@/plugins/city'
import {
  PREFIX_SCB_API,
  PREFIX_KS_SORDER,
  PREFIX_SCATERP,
  PREFIX_SVSACTIVITY_API,
  PREFIX_SCC_API
} from '@/service/constants'

export async function fetchConfirm2home(order, workState) {
  try {
    const { orderId } = order
    const { uid, skey } = await utils.ensureLogin()
    const url = PREFIX_SCATERP + 'comfirmTheHouseHold.do'
    const queryStr = queryString.stringify({ orderId, uid, skey, workState })
    const res = await fetch(`${url}?${queryStr}`)
    const j = await res.json()
    return +j.code === 1
  } catch (error) {
    throw error
  }
}

export async function handleOrderSas(orderId, source, state) {
  // orderId 订单号                                   必传
  // source 类型 0 售后 1 退款                        必传
  // state 状态    0 申请 1 撤销                     必传
  // 需要登录态
  try {
    // const {uid, skey} = await utils.ensureLogin()
    const url = PREFIX_KS_SORDER + 'handleOrderSas.do'
    const { uid, skey } = await utils.ensureLogin()
    const queryStr = queryString.stringify({
      orderId,
      source,
      state,
      uid,
      skey
    })
    const res = await fetch(`${url}?${queryStr}`)
    const j = await res.json()
    return +j.code === 1
  } catch (error) {
    throw error
  }
}

export async function getBusinessInfo(accountName) {
  const url = `${PREFIX_SCB_API}business/queryBusinessBaseInfo.do?accountName=${accountName}`
  try {
    const response = await fetch(url)
    return await response.json()
  } catch (error) {
    throw error
  }
}

/* App端工单创建 */
export async function addWork(param) {
  // workType 工单类型(1：售前，2：售后)
  // serviceDemand 服务需求
  // source 来源渠道(1：电销，2：地推，3：线下物料，4：线上渠道，5：员工收集，6：心愿单 7：订单)
  // sourceId  来源渠道业务ID，如订单号
  // sourceType  来源渠道工单类型（0:售前 1:更换月嫂 2：申请退款 3：修改上户日期）
  // remarks  工单备注
  try {
    const url = `${PREFIX_SVSACTIVITY_API}appwork/addWorkByApp.do`
    const { workType, serviceDemand, source, sourceId, sourceType, remarks } =
      param
    const paramStr = JSON.stringify({
      workType,
      serviceDemand,
      source,
      sourceId,
      sourceType,
      remarks
    })
    const res = await fetch(`${url}?param=${paramStr}`)
    const j = await res.json()
    return +j.code === 1
  } catch (error) {
    throw error
  }
}

// 获取月嫂服务动态
export const yuesaoServiceInfo = async param => {
  const apiUrl = `https://soperationapi.czj100.com/soperation-api/comment/getYuesaoServiceInfo.do`
  return http.get(`${apiUrl}`, param)
}

// 获取月嫂收获锦旗
export const yuesaoFlagInfo = async param => {
  const apiUrl = `https://soperationapi.czj100.com/soperation-api/comment/getYuesaoBannerInfo.do`
  return http.get(`${apiUrl}`, param)
}

// 预约月嫂服务
export async function orderYuesao(params) {
  const { cityId, cityName, memberUid, uid, workerCode } = params
  const param = queryString.stringify({
    cityId,
    cityName,
    memberUid,
    uid,
    workerCode,
    clueCategory: CLUE_CATEGORY.YUESAO,
    clueSource: CLUE_SOURE.ORDER_YUESAO
  })
  const orderApiUrl = `https://sccapi.cekid.com/scc-api/fchild/maternity/addWorkerAppointment.do?${param}`
  return http.get(orderApiUrl)
}

export const createNeedFormData = {
  categoryId: '10112210', // 签约月嫂categoryId写死
  utm: 'sx' // 个人页渠道码写死sx
}

// 收集月嫂需求表单
export const createNeedFormService = async param => {
  const apiUrl = `https://svsactivity.haiziwang.com/svshd-web/appcustom/autoAddWorkerIntention.do`
  const data = {
    uid: Cookie.get('uid'), // uid 配合skey验证登录态
    skey: Cookie.get('skey'), // skey 配合uid验证登录态
    utm: createNeedFormData.utm // 个人页渠道码写死sx
  }
  return http.post(`${apiUrl}`, { ...param, ...data })
}
